export type OperationUserUnauthenticated = 'unauthenticated'
export type OperationUserAuthenticated = 'authenticated'
export type OperationUserStaff = 'staff'
export type OperationUserVet = 'vet'

export type OperationUserTypes =
  | OperationUserUnauthenticated
  | OperationUserAuthenticated
  | OperationUserStaff
  | OperationUserVet

export type Operation = {
  url: string
  user_type: OperationUserTypes
  authEndpoint?: boolean
}

export type AvailableOperations =
  | 'GET_CLAIMS'
  | 'POST_CLAIMS'
  | 'GET_CLAIM'
  | 'GET_DOCUMENT_REQUEST'
  | 'GET_DOCUMENT_REQUESTS'
  | 'GET_DOCUMENT_REQUESTS_FOR_CLAIM'
  | 'GET_DOCUMENT_REQUESTS_FOR_OWNER'
  | 'POST_DOCUMENT_REQUEST_UPLOAD_URL'
  | 'POST_DOCUMENT_REQUEST_PRESIGNED_URL'
  | 'POST_DOCUMENT_REQUEST_FULFIL'
  | 'POST_DOCUMENT_UPLOAD_URL'
  | 'GET_POLICY_V2'
  | 'GET_POLICIES_V2'
  | 'GET_POLICIES'
  | 'GET_POLICY_LIMITS'
  | 'GET_CALCULATIONS'
  | 'GET_VET_PRACTICES'
  | 'GET_VET_PRACTICES_SEARCH'
  | 'GET_VET_USER'
  | 'PATCH_VET_USER'
  | 'VET_USER_TRIGGER_PASSWORD_CHANGE'

// API operations that require the claim's branch practice ID in place of the main practice ID
// for main/branch practices
export const BranchPracticeOperations = [
  'GET_CLAIM',
  'GET_DOCUMENT_REQUESTS_FOR_CLAIM',
]

export type ApiGetOptions = {
  pathOptions?: {
    [key: string]: any
  }
  queryParams?: {
    [key: string]: any
  }
  body?: {
    [key: string]: any
  }
}

export interface ListResponse<T> {
  _embedded: {
    items: T[]
  }
  _meta: {
    max_results: number
    page: number
    total: number
    total_losses?: number
  }
}
